function DartSvgDefs() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
      <defs>
        {/* Barrel */}
        <symbol id="dart-barrel" viewBox="0 0 80 360">
          <defs>
            <linearGradient id="g-steel" x1="0" x2="1" y1="0" y2="0">
              <stop offset="0" stopColor="#7d8590"/>
              <stop offset="0.4" stopColor="#dde4ec"/>
              <stop offset="0.7" stopColor="#aab4c1"/>
              <stop offset="1" stopColor="#5e6772"/>
            </linearGradient>
          </defs>
          <path d="M 22 6 L 58 6 L 56 320 Q 40 360 24 320 Z" fill="url(#g-steel)"/>
          <g fill="#3b4654" opacity="0.55">
            <rect x="22" y="40" width="36" height="3"/>
            <rect x="22" y="58" width="36" height="3"/>
            <rect x="22" y="76" width="36" height="3"/>
            <rect x="22" y="94" width="36" height="3"/>
            <rect x="22" y="112" width="36" height="3"/>
            <rect x="22" y="130" width="36" height="3"/>
          </g>
          <g fill="#1d3a8f">
            <rect x="22" y="156" width="36" height="6"/>
            <rect x="22" y="170" width="36" height="6"/>
            <rect x="22" y="184" width="36" height="6"/>
            <rect x="22" y="198" width="36" height="6"/>
            <rect x="22" y="212" width="36" height="6"/>
            <rect x="22" y="226" width="36" height="6"/>
            <rect x="22" y="240" width="36" height="6"/>
            <rect x="22" y="254" width="36" height="6"/>
          </g>
          <g fill="#2e3a4d" opacity="0.5">
            <rect x="24" y="276" width="32" height="2"/>
            <rect x="24" y="282" width="32" height="2"/>
            <rect x="24" y="288" width="32" height="2"/>
            <rect x="24" y="294" width="32" height="2"/>
            <rect x="24" y="300" width="32" height="2"/>
          </g>
          <rect x="32" y="6" width="6" height="320" fill="#ffffff" opacity="0.35"/>
        </symbol>

        {/* Flight */}
        <symbol id="dart-flight" viewBox="0 0 220 360">
          <defs>
            <linearGradient id="g-flight" x1="0" x2="1" y1="0" y2="0">
              <stop offset="0" stopColor="#0e3fad"/>
              <stop offset="0.5" stopColor="#1f5be0"/>
              <stop offset="1" stopColor="#0a2a8a"/>
            </linearGradient>
          </defs>
          <path d="M 110 6 L 210 110 L 110 250 L 10 110 Z" fill="url(#g-flight)"/>
          <line x1="110" y1="6" x2="110" y2="250" stroke="#ffffff" strokeOpacity="0.5" strokeWidth="2"/>
          <g transform="translate(120 60) scale(0.9)">
            <circle cx="20" cy="20" r="20" fill="#f5b815"/>
            <circle cx="13" cy="15" r="2.6" fill="#1d3a8f"/>
            <circle cx="27" cy="15" r="2.6" fill="#1d3a8f"/>
            <path d="M 12 22 Q 20 31 28 22" stroke="#1d3a8f" strokeWidth="3" fill="none" strokeLinecap="round"/>
          </g>
          <rect x="100" y="250" width="20" height="100" fill="#1f5be0"/>
          <rect x="104" y="346" width="12" height="14" fill="#0a2a8a"/>
        </symbol>

        {/* Shaft */}
        <symbol id="dart-shaft" viewBox="0 0 80 360">
          <defs>
            <linearGradient id="g-shaft" x1="0" x2="1">
              <stop offset="0" stopColor="#8a949f"/>
              <stop offset="0.5" stopColor="#e2e8ee"/>
              <stop offset="1" stopColor="#5d6772"/>
            </linearGradient>
          </defs>
          <path d="M 24 0 L 56 0 L 56 60 L 24 60 Z" fill="url(#g-shaft)"/>
          <g stroke="#3a4452" strokeWidth="2" opacity="0.6">
            <line x1="32" y1="0" x2="32" y2="60"/>
            <line x1="40" y1="0" x2="40" y2="60"/>
            <line x1="48" y1="0" x2="48" y2="60"/>
          </g>
          <rect x="32" y="60" width="16" height="240" fill="url(#g-shaft)"/>
          <g fill="#5a6470">
            <rect x="34" y="304" width="12" height="2"/>
            <rect x="34" y="310" width="12" height="2"/>
            <rect x="34" y="316" width="12" height="2"/>
            <rect x="34" y="322" width="12" height="2"/>
            <rect x="34" y="328" width="12" height="2"/>
            <rect x="34" y="334" width="12" height="2"/>
            <rect x="34" y="340" width="12" height="2"/>
            <rect x="34" y="346" width="12" height="2"/>
          </g>
          <rect x="38" y="60" width="2" height="240" fill="#ffffff" opacity="0.5"/>
        </symbol>

        {/* Tip */}
        <symbol id="dart-tip" viewBox="0 0 80 360">
          <defs>
            <linearGradient id="g-tip" x1="0" x2="1">
              <stop offset="0" stopColor="#7d8690"/>
              <stop offset="0.5" stopColor="#dde4ec"/>
              <stop offset="1" stopColor="#5e6772"/>
            </linearGradient>
          </defs>
          <rect x="28" y="290" width="24" height="12" fill="#3a4452"/>
          <g fill="#5a6470">
            <rect x="28" y="302" width="24" height="3"/>
            <rect x="28" y="308" width="24" height="3"/>
            <rect x="28" y="314" width="24" height="3"/>
            <rect x="28" y="320" width="24" height="3"/>
            <rect x="28" y="326" width="24" height="3"/>
          </g>
          <circle cx="40" cy="338" r="6" fill="#1a1a1a"/>
          <path d="M 32 290 L 48 290 L 50 100 L 40 12 L 30 100 Z" fill="url(#g-tip)"/>
          <g stroke="#3a4452" strokeWidth="1" opacity="0.4">
            <line x1="32" y1="120" x2="48" y2="140"/>
            <line x1="48" y1="120" x2="32" y2="140"/>
            <line x1="32" y1="150" x2="48" y2="170"/>
            <line x1="48" y1="150" x2="32" y2="170"/>
            <line x1="32" y1="180" x2="48" y2="200"/>
            <line x1="48" y1="180" x2="32" y2="200"/>
            <line x1="32" y1="210" x2="48" y2="230"/>
            <line x1="48" y1="210" x2="32" y2="230"/>
          </g>
          <path d="M 38 100 L 40 14 L 42 100 Z" fill="#ffffff" opacity="0.5"/>
        </symbol>

        {/* Full dart assembled */}
        <symbol id="dart-full" viewBox="0 0 200 600">
          <path d="M 100 0 L 175 50 L 100 130 L 25 50 Z" fill="#1d4cc4"/>
          <line x1="100" y1="0" x2="100" y2="130" stroke="#fff" strokeOpacity="0.45" strokeWidth="2"/>
          <g transform="translate(115 30) scale(0.5)">
            <circle cx="20" cy="20" r="20" fill="#f5b815"/>
            <circle cx="13" cy="15" r="2.6" fill="#1d3a8f"/>
            <circle cx="27" cy="15" r="2.6" fill="#1d3a8f"/>
            <path d="M 12 22 Q 20 31 28 22" stroke="#1d3a8f" strokeWidth="3" fill="none" strokeLinecap="round"/>
          </g>
          <rect x="92" y="130" width="16" height="120" fill="#cdd6df"/>
          <path d="M 80 250 L 120 250 L 116 440 Q 100 470 84 440 Z" fill="#cdd6df"/>
          <g fill="#1d3a8f">
            <rect x="80" y="270" width="40" height="6"/>
            <rect x="80" y="282" width="40" height="6"/>
            <rect x="80" y="294" width="40" height="6"/>
            <rect x="80" y="306" width="40" height="6"/>
            <rect x="80" y="318" width="40" height="6"/>
            <rect x="80" y="330" width="40" height="6"/>
            <rect x="80" y="342" width="40" height="6"/>
            <rect x="80" y="354" width="40" height="6"/>
            <rect x="80" y="366" width="40" height="6"/>
          </g>
          <path d="M 88 440 L 112 440 L 100 596 Z" fill="#aab4c1"/>
        </symbol>

        {/* Icons */}
        <symbol id="i-user" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="8" r="4"/>
          <path d="M4 21c0-4 4-7 8-7s8 3 8 7"/>
        </symbol>
        <symbol id="i-cart" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round">
          <path d="M5 6h15l-2 11H7L5 6z"/>
          <path d="M5 6L4 3H1"/>
          <circle cx="9" cy="20" r="1.4" fill="currentColor"/>
          <circle cx="17" cy="20" r="1.4" fill="currentColor"/>
        </symbol>
        <symbol id="i-search" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="7"/>
          <line x1="20" y1="20" x2="16.5" y2="16.5"/>
        </symbol>
        <symbol id="i-heart" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 21s-7-4.5-9.5-9C.7 8.6 3 5 6.5 5c2 0 3.5 1.2 4.5 2.7C12 6.2 13.5 5 15.5 5 19 5 21.3 8.6 21.5 12c-2.5 4.5-9.5 9-9.5 9z"/>
        </symbol>
        <symbol id="i-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="4" y1="12" x2="20" y2="12"/>
          <polyline points="14 6 20 12 14 18"/>
        </symbol>
        <symbol id="i-arrow-l" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="20" y1="12" x2="4" y2="12"/>
          <polyline points="10 6 4 12 10 18"/>
        </symbol>
        <symbol id="i-check" viewBox="0 0 1200 1200" fill="none" stroke="currentColor" strokeWidth="60" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="100 600 480 980 1100 200"/>
        </symbol>
        <symbol id="i-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <polyline points="6 9 12 15 18 9"/>
        </symbol>
        <symbol id="i-shield" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2l9 4v6c0 5-4 9-9 10-5-1-9-5-9-10V6l9-4z"/>
          <polyline points="9 12 11 14 15 10"/>
        </symbol>
        <symbol id="i-truck" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="1" y="6" width="14" height="11"/>
          <path d="M15 9h4l3 4v4h-7z"/>
          <circle cx="6" cy="19" r="2"/>
          <circle cx="18" cy="19" r="2"/>
        </symbol>
        <symbol id="i-return" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="3 9 8 4 13 9"/>
          <path d="M8 4v10a4 4 0 004 4h8"/>
        </symbol>
        <symbol id="i-share" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="6" cy="12" r="3"/>
          <circle cx="18" cy="6" r="3"/>
          <circle cx="18" cy="18" r="3"/>
          <line x1="8.5" y1="10.5" x2="15.5" y2="7"/>
          <line x1="8.5" y1="13.5" x2="15.5" y2="17"/>
        </symbol>
        <symbol id="i-trophy" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M6 4h12v6a6 6 0 01-12 0V4z"/>
          <path d="M6 6H3v3a3 3 0 003 3"/>
          <path d="M18 6h3v3a3 3 0 01-3 3"/>
          <line x1="12" y1="16" x2="12" y2="20"/>
          <rect x="8" y="20" width="8" height="2"/>
        </symbol>
        <symbol id="i-gift" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="20 12 20 22 4 22 4 12"/>
          <rect x="2" y="7" width="20" height="5"/>
          <line x1="12" y1="22" x2="12" y2="7"/>
          <path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/>
          <path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/>
        </symbol>
        <symbol id="i-lock" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="4" y="11" width="16" height="10" rx="2"/>
          <path d="M8 11V7a4 4 0 018 0v4"/>
        </symbol>
        <symbol id="i-eye" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z"/>
          <circle cx="12" cy="12" r="3"/>
        </symbol>
        <symbol id="i-coins" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="9"/>
          <path d="M9 9h4a2 2 0 010 4H9v4"/>
          <path d="M9 13h5"/>
        </symbol>
        <symbol id="i-shipping" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="1" y="6" width="14" height="11"/>
          <path d="M15 9h4l3 4v4h-7z"/>
          <circle cx="6" cy="19" r="2"/>
          <circle cx="18" cy="19" r="2"/>
        </symbol>
        <symbol id="i-bolt" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round">
          <polygon points="13 2 4 14 11 14 10 22 20 9 13 9 13 2"/>
        </symbol>
        <symbol id="i-mail" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="5" width="18" height="14" rx="2"/>
          <polyline points="3 7 12 13 21 7"/>
        </symbol>
        <symbol id="i-list" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="8" y1="6" x2="21" y2="6"/>
          <line x1="8" y1="12" x2="21" y2="12"/>
          <line x1="8" y1="18" x2="21" y2="18"/>
          <circle cx="3.5" cy="6" r="1"/>
          <circle cx="3.5" cy="12" r="1"/>
          <circle cx="3.5" cy="18" r="1"/>
        </symbol>
        <symbol id="i-plus" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="12" y1="5" x2="12" y2="19"/>
          <line x1="5" y1="12" x2="19" y2="12"/>
        </symbol>
        <symbol id="i-x" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="6" y1="6" x2="18" y2="18"/>
          <line x1="18" y1="6" x2="6" y2="18"/>
        </symbol>
        <symbol id="i-trash" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="3 6 5 6 21 6"/>
          <path d="M19 6l-1 14H6L5 6"/>
          <path d="M10 11v6M14 11v6"/>
          <path d="M9 6V4h6v2"/>
        </symbol>
        <symbol id="i-edit" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 20h9"/>
          <path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4z"/>
        </symbol>
        <symbol id="i-copy" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="9" y="9" width="12" height="12" rx="2"/>
          <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
        </symbol>
        <symbol id="i-bell" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9"/>
          <path d="M13.7 21a2 2 0 01-3.4 0"/>
        </symbol>
        <symbol id="i-pin" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 22s7-7 7-12a7 7 0 10-14 0c0 5 7 12 7 12z"/>
          <circle cx="12" cy="10" r="2.5"/>
        </symbol>
        <symbol id="dart-line" viewBox="0 0 200 600" fill="none" stroke="currentColor" strokeWidth="6" strokeLinejoin="round">
          <path d="M 100 4 L 175 54 L 100 130 L 25 54 Z"/>
          <line x1="100" y1="4" x2="100" y2="130"/>
          <rect x="92" y="130" width="16" height="120"/>
          <path d="M 80 250 L 120 250 L 116 440 Q 100 470 84 440 Z"/>
          <path d="M 88 440 L 112 440 L 100 596 Z"/>
        </symbol>
        <symbol id="silhouette-player" viewBox="0 0 200 250">
          <circle cx="100" cy="80" r="36" fill="#fff" opacity="0.55"/>
          <path d="M 40 250 Q 50 150 100 140 Q 150 150 160 250 Z" fill="#fff" opacity="0.55"/>
          <path d="M 100 130 L 165 105 L 175 95 L 110 125 Z" fill="#f5b815"/>
          <circle cx="173" cy="92" r="8" fill="#1d4cc4"/>
        </symbol>
      </defs>
    </svg>
  );
}

export default DartSvgDefs;
